import { render, staticRenderFns } from "./Modal-Backlog.vue?vue&type=template&id=26b337d6&"
import script from "./Modal-Backlog.vue?vue&type=script&lang=js&"
export * from "./Modal-Backlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports